import moment from 'moment'
import { DATE_TIME_FORMAT } from '../constants'
import { JobAuditItem } from '../interfaces'
import { isLeftSafe } from '../utils'

const getTitle = (auditItem?: JobAuditItem) => {
    if (isLeftSafe(auditItem?.POD?.name)) {
        return 'Item left safe'
    }
    const { description } = auditItem ?? {}
    if (description?.includes('STOP COMPLETED')) {
        return 'Item delivered'
    }
    if (description?.includes('JOB COLLECTED')) {
        return 'Item collected'
    }
    return ''
}

export const usePodModalProps = (auditItem?: JobAuditItem) => {
    const { dateTime, POD } = auditItem ?? {}
    const title = getTitle(auditItem)
    const time = moment(dateTime).format(DATE_TIME_FORMAT)
    const image = POD?.signature ?? ''

    return {
        title,
        time,
        image,
    }
}
